import {RootStore} from "./RootStore";

export default function getStoreFromProps<T extends typeof RootStore, V extends keyof T>(props:any,key:V){
    var stores = props as T;
    return stores [key];
}